export default __webpack_public_path__ + "icon_information.5a402282158521a959ad590ca37cce55.svg";